import type * as React from 'react';

import { BuildingWrapper } from '../../components/Building';
import { BuildingHeader } from '../BuildingHeader';
import { Address } from '../Address';
import { Description } from '../Description';
import { LayoutLinks } from '../LayoutLinks';

export const Building = (): React.JSX.Element => {
  return (
    <BuildingWrapper
      header={<BuildingHeader />}
      address={<Address />}
      description={<Description />}
      layoutLinks={<LayoutLinks />}
    />
  );
};
